import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePushtokenMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
  token?: Types.InputMaybe<Types.Scalars['String']['input']>;
  deviceInfo?: Types.InputMaybe<Types.DeviceInput>;
}>;


export type UpdatePushtokenMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string } };


export const UpdatePushtokenDocument = gql`
    mutation UpdatePushtoken($userId: String!, $token: String, $deviceInfo: DeviceInput) {
  updateUser(data: {id: $userId, pushToken: $token, device: $deviceInfo}) {
    id
  }
}
    `;
export type UpdatePushtokenMutationFn = Apollo.MutationFunction<UpdatePushtokenMutation, UpdatePushtokenMutationVariables>;

/**
 * __useUpdatePushtokenMutation__
 *
 * To run a mutation, you first call `useUpdatePushtokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePushtokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePushtokenMutation, { data, loading, error }] = useUpdatePushtokenMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      token: // value for 'token'
 *      deviceInfo: // value for 'deviceInfo'
 *   },
 * });
 */
export function useUpdatePushtokenMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePushtokenMutation, UpdatePushtokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePushtokenMutation, UpdatePushtokenMutationVariables>(UpdatePushtokenDocument, options);
      }
export type UpdatePushtokenMutationHookResult = ReturnType<typeof useUpdatePushtokenMutation>;
export type UpdatePushtokenMutationResult = Apollo.MutationResult<UpdatePushtokenMutation>;
export type UpdatePushtokenMutationOptions = Apollo.BaseMutationOptions<UpdatePushtokenMutation, UpdatePushtokenMutationVariables>;